module.exports = __webpack_public_path__ + "img/ezDDkrPs.b9b1faac.svg";